import React from "react";

// Extracted data lists to keep the JSX clean and maintainable
const preCareItems = [
  "Avoid waxing or threading within 15 days of your service.",
  "Avoid micro-needling, chemical peels, and bleaching within 7 days of your service.",
  "Avoid using medicated creams like retinol and steroids within 7 days of your service.",
  "Avoid laser treatment if you have any open wounds, cuts, bruises, or active skin infections."
];

const postCareItems = [
  "Apply a high SPF sunscreen (at least SPF 50) and keep your skin well-moisturized.",
  "Use gentle skincare products and refrain from plucking, waxing, or threading.",
  "Avoid hot baths, saunas, and intense, sweaty activities for at least 2 days after each session."
];

function Care() {
  // Reusable Checkmark Icon Component
  const CheckIcon = () => (
    <svg
      className="text-success me-3 flex-shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
        clipRule="evenodd"
      />
    </svg>
  );

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content border-0 shadow-lg rounded-4">
          
          {/* Modal Header */}
          <div className="modal-header border-bottom-0 pt-4 px-4">
            <h5 className="modal-title fw-bold text-dark" id="exampleModalLabel">
              Pre & Post Care Guide
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body px-4 pb-4">
            
            {/* Pre-Laser Care Section */}
            <div className="mb-4">
              <h6 className="text-primary fw-bold text-uppercase small tracking-wider mb-3">
                Pre-Laser Care
              </h6>
              <ul className="list-group list-group-flush">
                {preCareItems.map((item, index) => (
                  <li key={index} className="list-group-item d-flex align-items-start border-0 px-0 py-2 bg-transparent text-secondary">
                    <CheckIcon />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Post-Laser Care Section */}
            <div>
              <h6 className="text-success fw-bold text-uppercase small tracking-wider mb-3">
                Post-Laser Care
              </h6>
              <ul className="list-group list-group-flush">
                {postCareItems.map((item, index) => (
                  <li key={index} className="list-group-item d-flex align-items-start border-0 px-0 py-2 bg-transparent text-secondary">
                    <CheckIcon />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

          </div>

          {/* Optional Footer spacing alignment */}
          <div className="modal-footer border-top-0 pt-0 pb-3"></div>
        </div>
      </div>
    </div>
  );
}

export default Care;